import * as React from 'react';
import { StyleSheet } from 'react-native'
import { linkColor } from '../../common/colors';
import { Text } from 'react-native-paper';

export default function Link(props) {

    return (
        <Text style={styles.link} onPress={props.onPress}>{props.children}</Text>
    );
}

const styles = StyleSheet.create({
    link: {
        color: linkColor,
        fontSize: 12,
        letterSpacing: 1.25,
        paddingLeft: 10,
    },
});